module.exports = __webpack_public_path__ + "img/Modernisme_Filmindustrien1.7efa51ad.jpg";